export var memo = function (fn) {
    var cache = new WeakMap();
    return function (arg) {
        if (!cache.has(arg))
            cache.set(arg, fn(arg));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return cache.get(arg);
    };
};
